import {
  roundAverageRating,
  roundStarRating,
} from '@virginexperiencedays/components-v2/src/utils/productRating';

import type {
  Product,
  Review as BaseReview,
  Reviews as BaseReviews,
} from '@virginexperiencedays/products';

export type Review = BaseReview & {
  responderName?: string;
};

export type Reviews = BaseReviews & {
  averageRatingDisplay: string;
  featured: Review[];
  // includes featured review as first in the list
  reviews: Review[];
};

type ReviewsExtractorProps = {
  individualReviews: Review[];
};

export const reviewsExtractor = (
  product: Product,
  { individualReviews }: ReviewsExtractorProps
): Reviews => {
  const productReview = product?.reviews;

  // Don't show rating and reviews for collection products
  // or if there are no reviews
  if (product?.isCollectionProduct || !productReview) return null;

  const roundedRating = roundStarRating(productReview?.averageRating);

  // Don't show rating and reviews if the average rating is less than minimum
  if (!roundedRating) return null;

  const reviews = Array.isArray(individualReviews) ? individualReviews : [];

  // top 2 with 5-star individual rating
  const featured =
    reviews.length > 0 ? reviews.filter((review) => review?.rating === 5).slice(0, 2) : [];

  return {
    ...productReview,
    // shows mobile = 3, desktop = 6, modal/drawer = all review items
    reviews,
    // shows mobile = 1, desktop = 2 review items
    featured,
    // show 1 zero decimal (e.g. 3 will be "3.0")
    averageRatingDisplay:
      roundAverageRating(productReview.averageRating) || `${productReview.averageRating}`,
  };
};
